import React from "react";

export default props => (
  <div style={{ color: "white", background: "red", padding: "1rem", textAlign: "center" }}>
    Couldn't found the corresponding component for {props.data.typeHandle}.
  </div>
);
